export default __webpack_public_path__ + "static/media/logocelularfire.c92604d5.png";